import { useEffect, useMemo } from 'react';

import { InvoiceDocumentDialog } from '~/components/invoices/detailPage/InvoiceDocumentDialog';
import { getTicketDocuments } from '~/components/invoices/detailPage/invoiceDocuments';
import { useTicketPreview } from '~/data/hooks/useTicket';

// Loads the ticket fresh: the row's document links may have expired.
export function TicketDocumentFromList({
  ticketId,
  onClose,
}: {
  ticketId: string;
  onClose: () => void;
}) {
  const { ticket, error, loading } = useTicketPreview(ticketId);
  const documents = useMemo(() => getTicketDocuments(ticket), [ticket]);

  useEffect(() => {
    if (error && !ticket) onClose();
  }, [error, ticket, onClose]);

  return (
    <InvoiceDocumentDialog
      open
      onClose={onClose}
      primaryDocuments={documents}
      supportingDocuments={[]}
      isLoading={loading || !ticket}
      emptyMessage="No document attached to this ticket."
      title={ticket ? `Ticket #${ticket.number}` : 'Preview Document'}
    />
  );
}
